module.exports = __webpack_public_path__ + "img/search-icon.ff44f0c2.svg";